// @flow
import React, { Component } from 'react'
import _ from 'lodash'
import type { Configs, OptionType, UrlCheckResult } from '../../types'
import postJson from '../../../services/postJson'
import VkUrlDebouncedChecker from '../../../services/callbacksDebouncer'
import { defaultVkLinkButton } from '../../constants'
import LinkButtons from './LinkButtons'

type Props = {|
  url: string,
  urlCheck?: ?UrlCheckResult,
  configs: Configs,
  vkValue: ?string,
  tmValue: ?string,
  fbValue: ?string,
  onVkChange: Function,
  onTmChange: Function,
  onFbChange: Function,
  hideVk?: boolean,
  hideTm?: boolean,
  hideFb?: boolean,
  vkErrors?: Array<string>,
  tmErrors?: Array<string>,
  fbErrors?: Array<string>,
  vkOptionsWithoutPublic?: boolean
|}

type State = {|
  isVkUrl: boolean,
  vkUrlType: 'default' | 'public' | 'group' | 'me' | 'app'
|}

const checkUrl = '/api/v1/check_vk_url'

export default class LinkButtonsContainer extends Component<Props, State> {
  vkUrlDebouncedChecker: any

  constructor(props: Props) {
    super(props)
    this.state = {
      isVkUrl: (props.urlCheck && props.urlCheck.is_vk_url) || false,
      vkUrlType: (props.urlCheck && props.urlCheck.type) || 'default'
    }

    this.vkUrlDebouncedChecker = new VkUrlDebouncedChecker(1500)
    this.vkUrlDebouncedChecker.onChange(() => this.checkVkUrl())
  }

  componentDidUpdate(prevProps: Props) {
    if (!this.props.hideVk && !_.isEqual(prevProps.url, this.props.url)) {
      this.vkUrlDebouncedChecker.debouncedOnChange()
    }
  }

  render() {
    return (
      <LinkButtons
        hideVk={this.props.hideVk}
        hideTm={this.props.hideTm}
        hideFb={this.props.hideFb}
        vkOptions={this.vkOptions()}
        tmOptions={this.props.configs.tmLinkButtonOptions}
        fbOptions={this.props.configs.fbLinkButtonOptions}
        vkValue={this.props.vkValue}
        tmValue={this.props.tmValue}
        fbValue={this.props.fbValue}
        onVkChange={this.props.onVkChange}
        onTmChange={this.props.onTmChange}
        onFbChange={this.props.onFbChange}
        vkErrors={this.props.vkErrors}
        tmErrors={this.props.tmErrors}
        fbErrors={this.props.fbErrors}
      />
    )
  }

  isShown() {
    return !this.props.hideVk || !this.props.hideTm || !this.props.hideFb
  }

  vkOptions(): Array<OptionType> {
    const { vkOptionsWithoutPublic, configs } = this.props
    const { isVkUrl, vkUrlType } = this.state
    if (isVkUrl && vkUrlType === 'me') return configs.vkMeLinkButtonOptions
    if (isVkUrl && vkUrlType === 'app') return configs.vkAppLinkButtonOptions
    if (isVkUrl && vkUrlType === 'public') return configs.vkPublicLinkButtonOptions
    if (isVkUrl && vkUrlType === 'group') return configs.vkGroupLinkButtonOptions
    return vkOptionsWithoutPublic
      ? configs.vkWithoutPublicLinkButtonOptions
      : configs.vkWithButtonLinkButtonOptions
  }

  checkVkUrl() {
    const { url, onVkChange } = this.props
    postJson(checkUrl, { data: { url: url } })
      .done((response) => {
        if (response.data.ready) {
          if (response.data.is_vk_url) {
            this.setState({ isVkUrl: true, vkUrlType: response.data.type })
          } else {
            this.setState({ isVkUrl: false })
          }
        } else {
          this.vkUrlDebouncedChecker.debouncedOnChange()
        }
      })
      .always(() => {
        onVkChange(defaultVkLinkButton)
      })
  }
}
